(function () {
  var section = document.querySelector('.rheon-build');
  var catalogue = window.RHEON_CATALOGUE;
  if (!section || !catalogue) return;

  var discountPct = parseFloat(section.dataset.bundleDiscount) || catalogue.bundleDiscount || 20;

  var summaryItems = section.querySelector('.rheon-summary__items');
  var summaryTotal = section.querySelector('.rheon-summary__total');
  var summaryWas = section.querySelector('.rheon-summary__was');
  var discountNote = section.querySelector('.rheon-summary__discount-note');
  var addBtn = section.querySelector('#rheon-add-to-cart');

  // Each category now holds an ARRAY of selected product ids, not a single value.
  var selection = { elbow: [], shoulder: [], back: [] };

  function money(n) {
    n = parseFloat(n) || 0;
    return '\u00A3' + (Math.round(n * 100) / 100).toFixed(2);
  }

  function cardHtml(product) {
    return (
      '<div class="rheon-pcard" data-id="' + product.id + '">' +
        '<button type="button" class="rheon-pcard__img-btn" data-action="spec">' +
          '<img src="' + product.image + '" alt="' + product.name + '" loading="lazy">' +
          '<span class="rheon-pcard__spec-hint">View spec</span>' +
        '</button>' +
        '<div class="rheon-pcard__body">' +
          '<p class="rheon-pcard__name">' + product.name + '</p>' +
          '<p class="rheon-pcard__meta">' + product.weight + ' &middot; ' + product.thickness + '</p>' +
          '<p class="rheon-pcard__price">' + money(product.price) + (product.pair ? ' / pair' : '') + '</p>' +
          '<button type="button" class="rheon-pcard__select" data-action="select">Select</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderRows() {
    ['elbow', 'shoulder', 'back'].forEach(function (category) {
      var row = section.querySelector('.rheon-row[data-row="' + category + '"]');
      if (!row) return;
      row.innerHTML = catalogue[category].map(cardHtml).join('');
    });
  }

  function findProduct(category, id) {
    return catalogue[category].find(function (p) { return p.id === id; });
  }

  function isSelected(category, id) {
    return selection[category].indexOf(id) !== -1;
  }

  function updateCardStates() {
    ['elbow', 'shoulder', 'back'].forEach(function (category) {
      var row = section.querySelector('.rheon-row[data-row="' + category + '"]');
      if (!row) return;
      row.querySelectorAll('.rheon-pcard').forEach(function (card) {
        var selected = isSelected(category, card.dataset.id);
        card.classList.toggle('rheon-pcard--selected', selected);
        var btn = card.querySelector('.rheon-pcard__select');
        if (btn) btn.textContent = selected ? 'Remove' : 'Select';
      });
    });
  }

  function getAllSelectedProducts() {
    var all = [];
    ['elbow', 'shoulder', 'back'].forEach(function (category) {
      selection[category].forEach(function (id) {
        var p = findProduct(category, id);
        if (p) all.push(p);
      });
    });
    return all;
  }

  function renderSummary() {
    var chosen = getAllSelectedProducts();

    if (!chosen.length) {
      summaryItems.textContent = 'Select your protectors above';
      summaryTotal.textContent = money(0);
      summaryWas.hidden = true;
      discountNote.hidden = true;
      addBtn.disabled = true;
      return;
    }

    var subtotal = chosen.reduce(function (sum, p) { return sum + (parseFloat(p.price) || 0); }, 0);
    var isFullBundle = selection.elbow.length > 0 && selection.shoulder.length > 0 && selection.back.length > 0;

    summaryItems.textContent = chosen.map(function (p) { return p.name; }).join(' + ');

    if (isFullBundle) {
      var discounted = subtotal * (1 - discountPct / 100);
      summaryWas.hidden = false;
      summaryWas.textContent = money(subtotal);
      summaryTotal.textContent = money(discounted);
      discountNote.hidden = false;
    } else {
      summaryWas.hidden = true;
      summaryTotal.textContent = money(subtotal);
      discountNote.hidden = true;
    }

    addBtn.disabled = false;
  }

  function toggleProduct(category, id) {
    var idx = selection[category].indexOf(id);
    if (idx === -1) {
      selection[category].push(id);
    } else {
      selection[category].splice(idx, 1);
    }
    updateCardStates();
    renderSummary();
  }

  // ---- MODAL ----
  var modal = document.getElementById('rheon-modal');
  var modalImage = modal.querySelector('.rheon-modal__image');
  var modalTitle = modal.querySelector('.rheon-modal__title');
  var modalPrice = modal.querySelector('.rheon-modal__price');
  var modalSpecTable = modal.querySelector('.rheon-spec-table');
  var modalFeatures = modal.querySelector('.rheon-modal__features');
  var modalSelectBtn = modal.querySelector('.rheon-modal__select');
  var modalCurrent = null;

  function openModal(category, product) {
    modalCurrent = { category: category, product: product };
    modalImage.innerHTML = '<img src="' + product.image + '" alt="' + product.name + '">';
    modalTitle.textContent = product.name;
    modalPrice.textContent = money(product.price) + (product.pair ? ' / pair' : '');
    modalSelectBtn.textContent = isSelected(category, product.id) ? 'Remove from bundle' : 'Select this protector';
    modalSpecTable.innerHTML =
      '<tr><th>Product code</th><td>' + product.code + '</td></tr>' +
      '<tr><th>Certification</th><td>' + product.en + '</td></tr>' +
      '<tr><th>Designation</th><td>' + product.designation + '</td></tr>' +
      '<tr><th>Weight</th><td>' + product.weight + '</td></tr>' +
      '<tr><th>Thickness</th><td>' + product.thickness + '</td></tr>' +
      '<tr><th>Dimensions</th><td>' + product.dimensions + '</td></tr>';
    modalFeatures.innerHTML =
      '<p><strong>Lightweight</strong> &mdash; made to feel invisible, allowing unrestricted movement.</p>' +
      '<p><strong>Breathable</strong> &mdash; unique cell design lets heat dissipate for a cooler ride.</p>' +
      '<p><strong>Flexible</strong> &mdash; soft and reactive, giving protection where and when it\u2019s needed.</p>';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    modalCurrent = null;
    document.body.style.overflow = '';
  }

  modal.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-modal-close')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
  modalSelectBtn.addEventListener('click', function () {
    if (modalCurrent) {
      toggleProduct(modalCurrent.category, modalCurrent.product.id);
      closeModal();
    }
  });

  // ---- ROW CLICK DELEGATION ----
  section.querySelectorAll('.rheon-row').forEach(function (row) {
    var category = row.dataset.row;
    row.addEventListener('click', function (e) {
      var card = e.target.closest('.rheon-pcard');
      if (!card) return;
      var product = findProduct(category, card.dataset.id);
      var action = e.target.closest('[data-action]');
      if (action && action.dataset.action === 'spec') {
        openModal(category, product);
      } else if (action && action.dataset.action === 'select') {
        toggleProduct(category, product.id);
      }
    });
  });

  addBtn.addEventListener('click', function () {
    var chosen = getAllSelectedProducts();
    if (!chosen.length) return;

    var lineItems = chosen
      .filter(function (p) { return p.variantId; })
      .map(function (p) { return { id: p.variantId, quantity: 1 }; });

    if (!lineItems.length) {
      alert('Product variants have not been connected to this section yet. Add the variant IDs in the theme customizer.');
      return;
    }

    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        alert('Something went wrong adding these to your cart. Please try again.');
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      });
  });

  renderRows();
  renderSummary();
})();